import { call, select, delay } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { request } from '../../xhr';
import { getGallectionType } from '../helpers';
function* setGallectionName(action) {
    yield delay(500); // + takeLatest = debounced
    const { folderId , name  } = action.payload;
    const gallection = yield select(getGallectionById, folderId);
    if (!gallection) {
        return;
    }
    var _getGallectionType;
    const params = {
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name
    };
    yield call(request, {
        method: 'post',
        url: 'gallection/folders/rename',
        data: params
    });
}
export default setGallectionName;
